module.exports = __webpack_public_path__ + "img/image02.a28049ab.jpg";